import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

const R = Resources.Inspiration.EarlyFreedom;

export const useEarlyFreedomYearsLabel = () => {
	const { t } = useResource();

	return (years: number | null) => {
		if (years === null) return t(R.paceNever);
		if (years === 0) return t(R.paceNow);
		return `${years} ${t(R.year, { count: years })}`;
	};
};
